import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=3002d386&"
import script from "./Shipping.vue?vue&type=script&lang=ts&"
export * from "./Shipping.vue?vue&type=script&lang=ts&"
import style0 from "./Shipping.vue?vue&type=style&index=0&id=3002d386&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports